import { Grid, TextField } from '@mui/material';
import React, { useContext } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import styledComponent from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ExtensionContext } from './ExtensionForm';
import { makeStyles } from 'tss-react/mui';
import { CustomCheckbox, RadioDropDown } from './CustomComponents';
import { ExtEditTarget } from '../PlacementDetails/PlacementTabPanel/PlacementSummaryTab/Statuses/Extensions/ExtensionEditIcon';

const useStyles = makeStyles()({
  cueNoteDropdown: {
    width: 300,
  },
});

export const Miscellaneous = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext();
  const { cueRecipients } = useContext(ExtensionContext);

  const isSentCueNote = watch('isSentCueNote');
  const { disabledFields, currentTargetField } = useContext(ExtensionContext);

  return (
    <Grid container direction="column">
      <Grid item>
        <Controller
          name="notes"
          control={control}
          render={({ field }) => (
            <CustomTextField
              {...field}
              autoFocus={!disabledFields.notes && currentTargetField === ExtEditTarget.notes}
              multiline
              variant="filled"
              label={t('placement.profile.summary.extension.notes')}
              onChange={e => field.onChange(e.target.value)}
              value={field.value}
              inputProps={{ maxLength: 4000 }}
              rows={3}
              disabled={disabledFields.notes}
            />
          )}
        />
      </Grid>
      <Grid item>
        <Controller
          name="amnHousing"
          control={control}
          render={({ field }) => (
            <CustomCheckbox
              autoFocus={!disabledFields.amnHousing && currentTargetField === ExtEditTarget.amnHousing}
              label={t('placement.profile.summary.extension.amnHousing')}
              {...field}
              disabled={disabledFields.amnHousing}
            />
          )}
        />
      </Grid>
      <Grid item>
        <Controller
          name="isSentCueNote"
          control={control}
          render={({ field }) => (
            <CustomCheckbox
              label={t('placement.profile.summary.extension.sendAsCueNote')}
              {...field}
              disabled={disabledFields.isSentCueNote}
            />
          )}
        />
      </Grid>
      {isSentCueNote && (
        <CueListContainer item>
          <Controller
            name="cueRecipient"
            control={control}
            render={({ field }) => (
              <RadioDropDown
                {...field}
                title={t('placement.profile.summary.extension.cueTo')}
                options={cueRecipients}
                overrideClasses={{ container: classes.cueNoteDropdown }}
                disabled={disabledFields.cueRecipient || disabledFields.isSentCueNote}
              />
            )}
          />
        </CueListContainer>
      )}
    </Grid>
  );
};

const CustomTextField = styledComponent(TextField)`
  min-width: -webkit-fill-available;
`;

const CueListContainer = styledComponent(Grid)`
  padding-left: 32px;
`;
